module.exports = __webpack_public_path__ + "static/img/10.070c8d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/zh/10.png
// module id = LCLj
// module chunks = 0